export const experience = [
  { value: 'Platinum_20plus', name: 'Platinum (20+)' },
  { value: 'Gold_10plus', name: 'Gold (10+)' },
  { value: 'Silver_4plus', name: 'Silver (4+)' },
  { value: 'Bronze_1_3', name: 'Bronze (1-3)' },
  { value: 'None_0', name: 'None (0)' },
];



// WEBPACK FOOTER //
// ./src/constants/experience.js